import { createActions } from "redux-actions";
import { NewsType } from "../../../types/main";

export enum GetGosInitDataActionsType {
  GET_GOS_INIT_DATA = "GET_GOS_INIT_DATA",
  GET_GOS_INIT_DATA_SUCCESS = "GET_GOS_INIT_DATA_SUCCESS",
  GET_GOS_INIT_DATA_FAILURE = "GET_GOS_INIT_DATA_FAILURE",
  GET_GOS_INIT_DATA_IDLE = "GET_GOS_INIT_DATA_IDLE",
}

export type ActionsType = keyof typeof GetGosInitDataActionsType;

const {
  getGosInitData,
  getGosInitDataSuccess,
  getGosInitDataFailure,
  getGosInitDataIdle,
} = createActions({
  [GetGosInitDataActionsType.GET_GOS_INIT_DATA]: () => undefined,
  [GetGosInitDataActionsType.GET_GOS_INIT_DATA_SUCCESS]: (payload: NewsType) =>
    payload,
  [GetGosInitDataActionsType.GET_GOS_INIT_DATA_FAILURE]: (error: Error) => ({
    error,
  }),
  [GetGosInitDataActionsType.GET_GOS_INIT_DATA_IDLE]: () => undefined,
});

export {
  getGosInitData,
  getGosInitDataSuccess,
  getGosInitDataFailure,
  getGosInitDataIdle,
};
